const debug = require('debug')('form-logic:memoize-promise')

const COERCIBLE_TYPES = new Set(['string', 'number', 'boolean'])

interface Options {
  fulfilledOnly: boolean
}

const defaults: Options = { fulfilledOnly: true }

export function memoizePromise<T, R>(
  fn: (value: T) => Promise<R>,
  { fulfilledOnly }: Options = defaults
) {
  interface MemoCache {
    [key: string]: ReturnType<typeof fn>
  }

  const cache: MemoCache = {}

  return (value: T) => {
    assertCoercible(value)

    const key = String(value)

    const cached = cache[key]

    if (cached) {
      debug('cache HIT for', value)
      return cached
    }

    debug('cache MISS for', value)

    return (cache[key] = new Promise((resolve, reject) => {
      fn(value).then(resolve, e => {
        if (fulfilledOnly) {
          debug('promise failed - removing from cache', value, e)

          delete cache[key]
        }
        reject(e)
      })
    }))
  }
}

function assertCoercible<T>(value: T) {
  if (value !== null && !COERCIBLE_TYPES.has(typeof value)) {
    throw new Error(
      `${typeof value} not in ${Array.from(COERCIBLE_TYPES)} or null`
    )
  }
}
